import script from "./UserRenewal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRenewal.vue?vue&type=script&setup=true&lang=js"

import "./UserRenewal.vue?vue&type=style&index=0&id=2ad6c520&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ad6c520"]])

export default __exports__